'use strict';

(function () {

const PAGES_I18N = {
    es: {
        index_h1: "7PRV — CAMISETAS STREETWEAR ESPAÑOL · REVELATION 2026",
        footer_tees: "Todas las camisetas",
        legal_cookies: "Política de Cookies",
        legal_contact: "Contacto",
        notfound_title: "Página no encontrada",
        notfound_text: "La página que buscas no existe.",
        contact_email_label: "CORREO",
        contact_hours_label: "RESPUESTA",
        contact_hours_text: "Respondemos en 24-48 horas laborables. Para pedidos, indica tu número de pedido.",
        contact_name: "NOMBRE",
        contact_email: "CORREO",
        contact_order: "Nº DE PEDIDO (OPCIONAL)",
        contact_message: "MENSAJE",
        contact_send: "ENVIAR →",
        contact_success: "MENSAJE ENVIADO. TE RESPONDEMOS PRONTO.",
        contact_error: "REVISA LOS CAMPOS MARCADOS",
        blog_empty: "PRÓXIMAMENTE. AQUÍ PUBLICAREMOS NOTICIAS DE LA FAMILIA Y DE LOS PRÓXIMOS DROPS.",
        article_back: "← VOLVER AL BLOG",
        search_title: "BUSCAR",
        search_btn: "BUSCAR",
        search_empty: "SIN RESULTADOS. PRUEBA CON OTRA PALABRA O VUELVE AL DROP.",
        search_more: "ARTÍCULOS Y PÁGINAS"
    },
    en: {
        index_h1: "7PRV — SPANISH STREETWEAR T-SHIRTS · REVELATION 2026",
        footer_tees: "All t-shirts",
        legal_cookies: "Cookie Policy",
        legal_contact: "Contact",
        notfound_title: "Page not found",
        notfound_text: "The page you are looking for does not exist.",
        contact_email_label: "EMAIL",
        contact_hours_label: "REPLY TIME",
        contact_hours_text: "We reply within 24-48 business hours. For orders, include your order number.",
        contact_name: "NAME",
        contact_email: "EMAIL",
        contact_order: "ORDER NUMBER (OPTIONAL)",
        contact_message: "MESSAGE",
        contact_send: "SEND →",
        contact_success: "MESSAGE SENT. WE WILL GET BACK TO YOU SOON.",
        contact_error: "CHECK THE HIGHLIGHTED FIELDS",
        blog_empty: "COMING SOON. NEWS FROM THE FAMILY AND UPCOMING DROPS WILL BE POSTED HERE.",
        article_back: "← BACK TO THE BLOG",
        search_title: "SEARCH",
        search_btn: "SEARCH",
        search_empty: "NO RESULTS. TRY ANOTHER WORD OR GO BACK TO THE DROP.",
        search_more: "ARTICLES & PAGES"
    },
    fr: {
        index_h1: "7PRV — T-SHIRTS STREETWEAR ESPAGNOL · REVELATION 2026",
        footer_tees: "Tous les t-shirts",
        legal_cookies: "Politique de Cookies",
        legal_contact: "Contact",
        notfound_title: "Page introuvable",
        notfound_text: "La page que tu cherches n'existe pas.",
        contact_email_label: "E-MAIL",
        contact_hours_label: "DÉLAI DE RÉPONSE",
        contact_hours_text: "Nous répondons sous 24-48 heures ouvrées. Pour une commande, indique ton numéro de commande.",
        contact_name: "NOM",
        contact_email: "E-MAIL",
        contact_order: "Nº DE COMMANDE (OPTIONNEL)",
        contact_message: "MESSAGE",
        contact_send: "ENVOYER →",
        contact_success: "MESSAGE ENVOYÉ. NOUS TE RÉPONDONS BIENTÔT.",
        contact_error: "VÉRIFIE LES CHAMPS INDIQUÉS",
        blog_empty: "BIENTÔT. LES NOUVELLES DE LA FAMILLE ET DES PROCHAINS DROPS SERONT PUBLIÉES ICI.",
        article_back: "← RETOUR AU BLOG",
        search_title: "RECHERCHER",
        search_btn: "RECHERCHER",
        search_empty: "AUCUN RÉSULTAT. ESSAIE UN AUTRE MOT OU RETOURNE AU DROP.",
        search_more: "ARTICLES ET PAGES"
    }
};

function register() {
    if (!window.I7PRV || typeof window.I7PRV.registerI18n !== 'function') return false;
    window.I7PRV.registerI18n(PAGES_I18N);
    return true;
}

if (!register()) {
    document.addEventListener('DOMContentLoaded', register, { once: true });
}

})();
